export const purpose_icons = {
    article: require("./board.svg").default,
    board: require("./board.svg").default,
    document: require("./document.svg").default,
    door: require("./door.svg").default,
    editDocument: require("./editDocument.svg").default,
    fastfood: require("./fastfood.svg").default,
    group: require("./group.svg").default,
    hamburgerMenu: require("./hamburgerMenu.svg").default,
    idCard: require("./idCard.svg").default,
    meetingRoom: require("./meetingRoom.svg").default,
    package: require("./package.svg").default,
    quick: require("./quick.svg").default,
    restaurant: require("./restaurant.svg").default,
    sensorDoor: require("./sensorDoor.svg").default,
    shipping: require("./shipping.svg").default,
    suitcase: require("./suitcase.svg").default,
};
